import { AppConfigSet, loadAppSetUp } from '@gjensidige/se-content-helpers';
import {
  fetchGenericIllustrations,
  IllustrationType
} from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

export class AppHelper {
  static AppTexts: any = {};
  static AppIllustrations: any = [];
  static CmsData: any = {};

  static getText = (key: string): string => {
    return AppHelper.AppTexts ? AppHelper.AppTexts[key] : '';
  };

  static fetchInitialData = async () => {
    const configSet = [AppConfigSet.GENERIC_ILLUSTRATION];
    const staticData = await loadAppSetUp('calculation-widget-se', configSet);
    AppHelper.AppTexts = staticData[0];
    AppHelper.AppIllustrations = JSON.stringify(staticData[1]);
  };

  static fetchImageUrl = async (
    fileName: string,
    fileType: IllustrationType
  ) => {
    return fetchGenericIllustrations(
      fileName,
      fileType,
      JSON.parse(AppHelper.AppIllustrations)
    );
  };

  static getEnonicContent = async (dataUrl: string, dataObject: any) => {
    //const response: any = await apiFetcher.postJson(dataUrl)
    let enonicData = {
      imageFileName: '',
      smallScreenImageFileName: '',
      headerText: '',
      imageAltText: '',
      regNumberLabel: '',
      regNumberPlaceHolder: '',
      cprNumberLabel: '',
      cprNumberPlaceHolder: '',
      cprNumberHelpText: '',
      calculateBtnLabel: '',
      footerMessage: ''
    };
    if (dataObject) {
      try {
        enonicData = JSON.parse(dataObject);
      } catch {
        return enonicData;
      }
    } else {
      const response: any = await apiFetcher.postJson(dataUrl);
      if (response.isOk()) {
        if (response.value) {
          enonicData = response.value;
        }
      }
    }
    return enonicData;
  };
}
